module.exports = __webpack_public_path__ + "static/media/training.eca33a7c.jpg";